import { render, staticRenderFns } from "./AddMaterialModal.vue?vue&type=template&id=39b5fd42&"
import script from "./AddMaterialModal.vue?vue&type=script&lang=js&"
export * from "./AddMaterialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports